export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /app/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 15